<template>
  <div>
    <div class="row">
      <div class="col-4">
        <b-card
          class="m-b-20"
          :title="currentItem.name"
          :img-src="getImage(currentItem.image)"
          img-alt="Image"
          img-top
          bg-variant="dark"
          text-variant="light"
        >
          <b-card-text>
            {{ currentItem.description }}
          </b-card-text>
        </b-card>
      </div>
      <div class="col-8">
        <!-- begin script item info -->
        <b-card
          class="m-b-20"
          header-tag="header"
          header-bg-variant="dark"
          header-text-variant="light"
        >
          <template v-slot:header>
            <h6 class="mb-0">Details</h6>
          </template>
          <b-card-text>
            <div class="f-s-14" v-if="!currentItem.parent">
              <b>{{ buttonSubcategoryLabel }}:</b>
              {{ currentItem.children.length }}
              <ul v-if="currentItem.children.length">
                <li
                  v-for="subCategory in currentItem.children"
                  :key="subCategory.id"
                >
                  {{ subCategory.name }}
                </li>
              </ul>
            </div>
            <div class="f-s-14" v-else>
              <b>{{ categoryLabel }}:</b> {{ currentItem.parent.name }}
            </div>
            <div class="f-s-14">
              <b>Active steps:</b> {{ filterCategorySteps(currentItem).length }}
            </div>
            <div class="f-s-14">
              <b>Active items:</b>
              {{ filterCategoryScriptItems(currentItem).length }}
            </div>
          </b-card-text>
        </b-card>
        <div class="row" v-if="!exportMode">
          <div class="col-xl-6">
            <b-card
              header-tag="header"
              header-bg-variant="dark"
              header-text-variant="light"
            >
              <template v-slot:header>
                <h6 class="mb-0">Files</h6>
              </template>
              <b-card-text>
                <vue-custom-scrollbar style="height: 150px">
                  <div class="row">
                    <div
                      class="m-20 text-center"
                      v-for="file in currentItem.files"
                      :key="file.id"
                    >
                      <a :href="fileUrl + file.fileFd" :download="file.fileFd">
                        <i
                          v-if="fileType(file.fileFd) == 'pdf'"
                          class="fas fa-file-pdf fa-5x"
                        />
                        <i
                          v-else-if="fileType(file.fileFd) == ('jpg' || 'jpeg')"
                          class="fas fa-file-image fa-5x"
                        />
                        <p class="text-black">{{ file.name }}</p>
                      </a>
                    </div>
                  </div>
                  <div v-if="!currentItem.files.length">
                    <p class="m-l-10">No files</p>
                  </div>
                </vue-custom-scrollbar>
              </b-card-text>
            </b-card>
          </div>
          <div class="col-xl-6">
            <b-card
              header-tag="header"
              header-bg-variant="dark"
              header-text-variant="light"
              class="m-b-20"
              v-if="currentItem.notes && !exportMode"
            >
              <template v-slot:header>
                <h6 class="mb-0">Notes</h6>
              </template>
              <b-card-text>
                <vue-custom-scrollbar style="height: 150px">
                  <ul
                    class="media-list media-list-with-divider media-messaging"
                  >
                    <li
                      class="media media-sm"
                      v-for="(note, index) in currentItem.notes"
                      :key="note.id"
                    >
                      <div class="media-body">
                        <h5 class="media-heading">Note #{{ index + 1 }}</h5>
                        <p>{{ note.content }}</p>
                      </div>
                    </li>
                    <li v-if="!currentItem.notes.length" class="media media-sm">
                      <div class="media-body">
                        <p>No notes</p>
                      </div>
                    </li>
                  </ul>
                </vue-custom-scrollbar>
              </b-card-text>
            </b-card>
            <!-- end script item info -->
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12" v-if="!currentItem.parent">
        <!-- begin subcategories in category -->
        <b-card
          class="m-b-20"
          header-tag="header"
          header-bg-variant="dark"
          header-text-variant="light"
          v-if="currentItem.children.length"
        >
          <template v-slot:header>
            <h6 class="mb-0">{{ buttonSubcategoryLabel }}</h6>
          </template>
          <b-card
            class="m-b-10"
            header-tag="header"
            header-bg-variant="gray"
            header-text-variant="white"
            no-body
            v-for="(subcategory, index) in currentItem.children"
            :key="subcategory.id"
          >
            <template v-slot:header>
              <b-card-sub-title sub-title-text-variant="light" class="mb-1">{{
                `${subcategoryLabel} #${index + 1}`
              }}</b-card-sub-title>
              <b-card-title class="mb-0">{{ subcategory.name }}</b-card-title>
            </template>
            <b-card-body>
              <b-row>
                <b-col cols="4" class="text-center">
                  <img
                    :src="getImage(subcategory.item)"
                    width="150px"
                    style="max-height: 150px"
                  />
                </b-col>
                <b-col cols="8">
                  <b>Active steps:</b>
                  {{ filterCategorySteps(subcategory).length }}<br />
                  <b>Active items:</b>
                  {{ filterCategoryScriptItems(subcategory).length }}<br />
                </b-col>
              </b-row>
            </b-card-body>
            <b-list-group flush>
              <b-list-group-item variant="secondary"
                ><b>Active items</b></b-list-group-item
              >
              <!-- begin items in subcategory -->
              <div v-if="itemsInSubcategory(subcategory.id).length">
                <b-list-group-item
                  v-for="(item, itemIndex) in itemsInSubcategory(
                    subcategory.id
                  )"
                  :key="item.id"
                >
                  <b-row>
                    <b-col cols="6" class="text-center">
                      <img
                        :src="getImage(item.image)"
                        width="125px"
                        style="max-height: 125px"
                      />
                    </b-col>
                    <b-col cols="6">
                      <b class="text-secondary">
                        {{ `Item #${itemIndex + 1}` }} </b
                      ><br />
                      <b class="f-s-14">Item details</b><br />
                      <b>Name: </b>
                      <span> {{ item.name }} </span><br />
                      <b> Description: </b>
                      <span> {{ item.description }} </span><br />
                      <b>Source: </b>{{ item.source }} <br />
                      <b>Total: </b>{{ item.amount }} {{ item.unit }} <br />
                      <b>Unit price: </b>{{ item.unitPrice }} <br />
                      <url-button
                        label="Go to"
                        :url="`/eventbank/${item.type.name.toLowerCase()}/items/${
                          item.id
                        }`"
                        class="btn-yellow btn-sm pull-right"
                      />
                    </b-col>
                  </b-row>
                  <!-- begin script items in item -->
                  <b-row
                    v-for="(sItem, sItemIndex) in getSciptItemsWithItem(
                      item.id
                    )"
                    :key="sItem.id"
                  >
                    <b-col cols="12">
                      <hr />
                      <b class="text-secondary">{{
                        `Active item #${sItemIndex + 1}`
                      }}</b>
                    </b-col>
                    <b-col cols="6" class="bg-light pt-1 pb-1">
                      <b class="f-s-14">Step details</b><br />
                      <b>Name: </b><span>{{ sItem.step.name }}</span>
                      <br />
                      <b>Stage: </b>
                      <span>
                        {{
                          getItemStage(sItem.step)
                            ? getItemStage(sItem.step).name
                            : '-'
                        }}
                      </span>
                      <br />
                      <b>Storyboard: </b>
                      <span>{{
                        getItemStoryboard(sItem.step)
                          ? getItemStoryboard(sItem.step).name
                          : '-'
                      }}</span>
                      <br />
                      <b>Description:</b>
                      {{
                        sItem.step.description ? sItem.step.description : '-'
                      }}
                      <br />
                      <b>Insights:</b>
                      {{ sItem.step.insights ? currentItem.budget : '-' }}<br />
                      <b>Target outcome:</b>
                      {{ sItem.step.target ? sItem.step.target : '-' }}<br />
                      <b>Responsible person:</b>
                      {{
                        sItem.step.responsiblePerson
                          ? sItem.step.responsiblePerson
                          : '-'
                      }}<br />
                      <b>Things to provide: </b>
                      <span>{{ sItem.step.plan ? sItem.step.plan : '-' }}</span>
                      <br />
                      <b>Production budget:</b>
                      {{ sItem.step.budget ? `${sItem.step.budget} €` : '-' }}
                      <br />
                    </b-col>
                    <b-col cols="6" class="bg-light pt-1 pb-1">
                      <b class="f-s-14">Script details</b><br />
                      <b>Starts: </b>
                      <span>{{ sItem.startTime ? sItem.startTime : '-' }}</span>
                      <br />
                      <b>Ends: </b>
                      <span>{{ sItem.endTime ? sItem.endTime : '-' }}</span>
                      <br />
                      <div v-if="sItem.setupStartTime && sItem.setupEndTime">
                        <b>Set up starts: </b>
                        <span>{{
                          sItem.setupStartTime ? sItem.setupStartTime : '-'
                        }}</span>
                        <br />
                        <b>Set down starts: </b>
                        <span>{{
                          sItem.setupEndTime ? sItem.setupEndTime : '-'
                        }}</span>
                        <br />
                      </div>
                      <b>Remarks: </b><span>{{ sItem.remarks }}</span>
                      <br />
                      <b>Required: </b>
                      <span>{{ sItem.amount }} {{ sItem.unit }}</span>
                      <br />
                    </b-col>
                  </b-row>
                  <!-- end script items in item -->
                </b-list-group-item>
              </div>
              <div v-else>
                <b-list-group-item
                  >No active items in
                  {{ subcategoryLabel.toLowerCase() }}</b-list-group-item
                >
              </div>
              <!-- end items in subcategory -->
            </b-list-group>
          </b-card>
        </b-card>
        <b-card
          class="m-b-20"
          header-tag="header"
          header-bg-variant="dark"
          header-text-variant="light"
          v-else
        >
          No {{ buttonSubcategoryLabel.toLowerCase() }} in {{ categoryLabel }}
        </b-card>
        <!-- end subcategories in category -->
      </div>
      <div class="col-12" v-else-if="currentItem.parent">
        <!-- begin items in subcategory -->
        <b-card
          class="m-b-20"
          header-tag="header"
          header-bg-variant="dark"
          header-text-variant="light"
        >
          <template v-slot:header>
            <h6 class="mb-0">Active items</h6>
          </template>
          <b-list-group flush>
            <!-- begin items in subcategory -->
            <div v-if="itemsInSubcategory(currentItem.id).length">
              <b-list-group-item
                v-for="(item, itemIndex) in itemsInSubcategory(currentItem.id)"
                :key="item.id"
              >
                <b-row>
                  <b-col cols="6" class="text-center">
                    <img
                      :src="getImage(item.image)"
                      width="125px"
                      style="max-height: 125px"
                    />
                  </b-col>
                  <b-col cols="6">
                    <b class="text-secondary">{{ `Item #${itemIndex + 1}` }}</b
                    ><br />
                    <b class="f-s-14">Item details</b><br />
                    <b>Name: </b><span>{{ item.name }}</span
                    ><br />
                    <b>Description: </b><span>{{ item.description }}</span
                    ><br />
                    <b>Source: </b>{{ item.source }} <br />
                    <b>Total: </b>{{ item.amount }} {{ item.unit }}
                    <url-button
                      label="Go to"
                      :url="`/eventbank/${item.type.name.toLowerCase()}/items/${
                        item.id
                      }`"
                      class="btn-yellow btn-sm pull-right"
                    />
                  </b-col>
                </b-row>
                <!-- begin script items in item -->
                <b-row
                  v-for="(sItem, sItemIndex) in getSciptItemsWithItem(item.id)"
                  :key="sItem.id"
                >
                  <b-col cols="12">
                    <hr />
                    <b class="text-secondary">
                      {{ `Active item #${sItemIndex + 1}` }}
                    </b>
                  </b-col>
                  <b-col cols="6" class="bg-light pt-1 pb-1">
                    <b class="f-s-14">Step details</b><br />
                    <b>Name: </b><span>{{ sItem.step.name }}</span>
                    <br />
                    <b>Stage: </b>
                    <span
                      >{{
                        getItemStage(sItem.step)
                          ? getItemStage(sItem.step).name
                          : '-'
                      }}
                    </span>
                    <br />
                    <b>Storyboard: </b>
                    <span>{{
                      getItemStoryboard(sItem.step)
                        ? getItemStoryboard(sItem.step).name
                        : '-'
                    }}</span>
                    <br />
                    <b>Description:</b>
                    {{ sItem.step.description ? sItem.step.description : '-'
                    }}<br />
                    <b>Insights:</b>
                    {{ sItem.step.insights ? currentItem.budget : '-' }}<br />
                    <b>Target outcome:</b>
                    {{ sItem.step.target ? sItem.step.target : '-' }}<br />
                    <b>Responsible person:</b>
                    {{
                      sItem.step.responsiblePerson
                        ? sItem.step.responsiblePerson
                        : '-'
                    }}<br />
                    <b>Things to provide: </b
                    ><span>{{ sItem.step.plan ? sItem.step.plan : '-' }}</span
                    ><br />
                    <b>Production budget:</b>
                    {{ sItem.step.budget ? `${sItem.step.budget} €` : '-'
                    }}<br />
                  </b-col>
                  <b-col cols="6" class="bg-light pt-1 pb-1">
                    <b class="f-s-14">Script details</b><br />
                    <b>{{ amountLabel }}: </b
                    ><span>{{ sItem.amount }} {{ sItem.item.unit }}</span
                    ><br />
                    <b>{{ descriptionLabel }}: </b
                    ><span>{{
                      sItem.description ? sItem.description : '-'
                    }}</span
                    ><br />
                    <div v-if="sItem.setupStartTime && sItem.setupEndTime">
                      <b>{{ timeLabel }}: </b
                      ><span>{{ sItem.startTime }} - {{ sItem.endTime }}</span
                      ><br />
                    </div>
                    <div v-if="sItem.setupStartTime && sItem.setupEndTime">
                      <b>Set up starts: </b
                      ><span>{{
                        sItem.setupStartTime ? sItem.setupStartTime : '-'
                      }}</span
                      ><br />
                      <b>Set down starts: </b
                      ><span>{{
                        sItem.setupEndTime ? sItem.setupEndTime : '-'
                      }}</span
                      ><br />
                    </div>
                    <div v-if="sItem.requirements">
                      <b>{{ requirementsLabel }}: </b
                      ><span>{{ sItem.requirements }}</span
                      ><br />
                    </div>
                    <b>Cost estimate: </b
                    ><span>{{
                      sItem.costEstimate ? `${sItem.costEstimate} €` : '-'
                    }}</span
                    ><br />
                    <b>Remarks: </b
                    ><span>{{ sItem.remarks ? sItem.remarks : '-' }}</span
                    ><br />
                  </b-col>
                </b-row>
                <!-- end script items in item -->
              </b-list-group-item>
            </div>
            <div v-else>
              <b-list-group-item
                >No active items in
                {{ subcategoryLabel.toLowerCase() }}</b-list-group-item
              >
            </div>
            <!-- end items in subcategory -->
          </b-list-group>
        </b-card>
        <!-- end items in subcategory -->
      </div>
      <!-- begin script item info -->
      <!--
            <div class="col-12 bg-light rounded p-t-10 m-b-10">
                <div class="bg-white rounded m-b-10 p-10">
                    <task-items-list 
                        :categories="categories" 
                        :step="null" 
                        :type="$route.params.level" 
                        :sItems="activeScriptItems" 
                        :getFullItem="getFullItem" 
                        :imgWidth="exportMode ? '150px' : null" 
                    />
                </div>
            </div>
            -->
      <!-- end script item info -->
    </div>
  </div>
</template>

<script>
//import TaskItemsList from '../task/TaskItemsList.vue'
import UrlButton from '../buttons/UrlButton.vue'

export default {
  props: [
    'categories',
    'items',
    'currentItem',
    'filterCategorySteps',
    'filterCategoryScriptItems',
    'buttonSubcategoryLabel',
    'categoryParent',
    'subcategoryLabel',
    'categoryLabel',
    'getFullItem',
    'getItemStoryboard',
    'getItemStage',
    'exportMode'
  ],
  components: {
    //TaskItemsList,
    UrlButton
  },
  data() {
    return {
      fullItem: null,
      fullStep: null,
      stepStoryboard: null,
      stepStage: null,
      mainCategoryTitle: 'Service category',
      subcategoryTitle: 'Service area',
      amountLabel: '',
      descriptionLabel: '',
      requirementsLabel: '',
      timeLabel: '',
      fileUrl: process.env.VUE_APP_API_URL + '/uploads/files/'
    }
  },
  methods: {
    getImage(image) {
      if (image == null) {
        return require('../../assets/images/no_image.jpg')
      } else {
        return process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd
      }
    },
    fileType(path) {
      return path.slice(path.lastIndexOf('.') + 1)
    },
    itemsInSubcategory(subcatId) {
      return this.items.filter((item) => {
        return (
          item.category &&
          item.category.id == subcatId &&
          item.scriptItems.length
        )
      })
    },
    getSciptItemsWithItem(itemId) {
      var activeScriptItems = this.filterCategoryScriptItems(this.currentItem)
      return activeScriptItems.filter((sItem) => {
        return sItem.item && sItem.item.id == itemId
      })
    },
    updateLabels() {
      switch (this.$route.params.level) {
        case 'space':
          this.amountLabel = 'Items required'
          this.descriptionLabel = 'Description'
          this.timeLabel = 'Event time of use'
          break
        case 'stuff':
          this.amountLabel = 'Items required'
          this.descriptionLabel = 'Intended use'
          this.timeLabel = 'Time of use'
          break
        case 'staff':
          this.amountLabel = 'Personnel required'
          this.descriptionLabel = 'Job description'
          this.timeLabel = 'Time active'
          this.requirementsLabel = 'Job requirements'
          break
        case 'service':
          this.amountLabel = 'Providers required'
          this.descriptionLabel = 'Description'
          this.timeLabel = 'Time active'
          this.requirementsLabel = 'Tasks to be done'
          break
        default:
          break
      }
    }
  },
  watch: {
    $route() {
      this.updateLabels()
    }
  },
  mounted() {
    this.updateLabels()
  }
}
</script>
